'use client';

import { Separator } from '../../atoms/Separator/Separator';
import { LatestUserReview } from '../LatestUserReview/LatestUserReview';
import { LicensingTable } from '../LicensingTable/LicensingTable';
import { ProductCompatibilityTable } from '../ProductCompatibilityTable/ProductCompatibilityTable';
import { PublisherInfoTable } from '../PublisherInfoTable/PublisherInfoTable';
import { ProductNutritionLabelsProps } from './ProductNutritionLabels.types';

export const ProductNutritionLabels = ({
  compatibility,
  licensing,
  publisher,
  latestUserReview,
  microcopy,
  onClickReadMore,
  onPackageDetailsClick,
  className = '',
}: ProductNutritionLabelsProps) => {
  const separatorClassName = 'mt-6 mb-6';
  return (
    <div className={className}>
      <ProductCompatibilityTable
        {...compatibility}
        microcopy={microcopy.compatibility}
        onPackageDetailsClick={onPackageDetailsClick}
      />
      <LicensingTable
        {...licensing}
        microcopy={microcopy.licensing}
        className="mt-6"
      />
      {latestUserReview && microcopy.latestUserReview && (
        <>
          <Separator className={separatorClassName} />
          <LatestUserReview
            {...latestUserReview}
            microcopy={microcopy.latestUserReview}
            onClickReadMore={onClickReadMore}
          />
        </>
      )}
      <Separator className={separatorClassName} />
      <PublisherInfoTable {...publisher} microcopy={microcopy.publisher} />
      <Separator className="mt-6" />
    </div>
  );
};
